/**
 * Route Dependencies
 */
const DealPipeline = r => require.ensure([], () => r(require('../components/deal-pipeline/views/DealPipeline')), 'deal-pipeline')
const DealPipelineStage = r => require.ensure([], () => r(require('../components/deal-pipeline/views/DealPipelineStage')), 'deal-pipeline')
const DealPipelineIndex = r => require.ensure([], () => r(require('../components/deal-pipeline/views/DealPipelineIndex')), 'deal-pipeline')

/**
 * Account Routes
 */
export default {
    path: 'deal-pipeline',
    component: DealPipeline,
    children: [
        {
            path: '',
            name: 'deal_pipeline',
            component: DealPipelineIndex
        },
        {
            path: ':stage',
            name: 'deal_pipeline.stage',
            component: DealPipelineStage
        }
    ]
}



// WEBPACK FOOTER //
// ./src/router/deal-pipeline.js